import React from 'react';

import classNames from 'classnames';

import { stateHooks } from '@nxte-nl/state-hooks';

import { MenuItemPresentational } from '../../types/common';
import { DropDownWrapper } from '../DropDownWrapper/DropDownWrapper';
import { Link, LinkIntent, LinkType } from '../Link/Link';
import { Typography } from '../Typography/Typography';
import { Arrow, Chevron } from '../icons';
import { ChevronColor } from '../icons/Chevron/Chevron';
import styles from './HeaderDropDown.module.css';

export const hooks = {
  useCloseDropdownOnBlur: (closeDropdown: () => void) => {
    return React.useCallback((e: React.FocusEvent<HTMLDivElement>) => {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        closeDropdown();
      }
    }, [closeDropdown]);
  },
};

export type Props = {
  className?: string;
  dropDownItems: MenuItemPresentational[];
  title: string;
};

export const HeaderDropDown = React.memo((props: Props) => {
  const {
    title,
    dropDownItems,
    className,
  } = props;

  const {
    value: isDropdownExpanded,
    toggle: handleDropdownClick,
    setFalse: closeDropdown,
  } = stateHooks.useBooleanState();

  const handleBlur = hooks.useCloseDropdownOnBlur(closeDropdown);

  return (
    <div className={classNames(styles.wrapper, className)}
      onBlur={handleBlur} tabIndex={0}
    >
      <div
        onClick={handleDropdownClick}
        className={classNames(styles.button, {
          [styles.expandedButton]: isDropdownExpanded,
        })}>
        <Typography
          variant='bodySubText1'
          className={classNames(
            styles.dropDownTitle,
            {
              [styles.expandedDropDownTitle]: isDropdownExpanded,
            },
          )}
        >
          {title}
        </Typography>

        <Chevron
          variant={isDropdownExpanded ? 'up' : 'down'}
          fill={
            isDropdownExpanded
              ? ChevronColor.secondaryHeaderActive
              : ChevronColor.secondaryHeader
          }
        />
      </div>
      {isDropdownExpanded && (
        <DropDownWrapper>
          <div className={styles.dropdownList}
          >
            {dropDownItems.map((item, idx) => (
              item.path?.href && <Link
                type={LinkType.Href}
                to={item.path.href}
                withoutHoverStyles={true}
                intent={LinkIntent.breadcrumbs}
                key={item.path.href + idx}
              >
                <div
                  className={styles.dropdownItem}
                >
                  {item.title}
                  <Arrow fill='black' className={styles.arrow}/>
                </div>
              </Link>
            ))}
          </div>
        </DropDownWrapper>
      )}
    </div>
  );
});
